import React from 'react';
import { CloseOutlined } from '@ant-design/icons';
import { Skeleton, Tooltip } from 'antd';
import { Content, ContentTextStyle, LineContainer, TitleTextStyle } from './UI';
import { IPromiseBasedObservable } from 'mobx-utils';
import { LegendItem } from '@project/store/Legend';
import { StyleLayerLegend } from './StyleLegend/StyleLayerLegend';
import { PhotoLayer } from '@datum-group/datum-map/lib';
import { PhotoMaterialStyleLegend } from './StyleLegend';
import { observer } from 'mobx-react';

type PromisedLegendItem = IPromiseBasedObservable<LegendItem>;

export interface LayerLegendProps {
  name: string;
  layer: PromisedLegendItem;
  renderCount?(total: number | undefined, layerName: string): number;
  onRemove?(value: string): void;
}

export const LayerLegend: React.FC<LayerLegendProps> = observer(
  (props: LayerLegendProps) => {
    const { layer, name, onRemove, renderCount } = props;

    return (
      <>
        {layer.case({
          pending: () => (
            <LineContainer
              content={<Skeleton avatar paragraph={{ rows: 1 }} />}
            />
          ),
          rejected: (err) => (
            <LineContainer
              content={
                <Content
                  content={`Не удалось отобразить легенду слоя ${name}! ${err}`}
                />
              }
            />
          ),
          fulfilled: (value) => {
            const title = value.description || value.name;

            const { icon, size: totalRecords } = value;

            const isTableSource = value.apiLayer.layer_type === 'Table';
            const isXYZSource = value.apiLayer.layer_type === 'XYZ';
            const isPhotoLayer = value.datumLayer instanceof PhotoLayer;

            if (isXYZSource) return;

            return (
              <>
                <LineContainer
                  height={!!renderCount ? 80 : 70}
                  icon={icon}
                  content={
                    <>
                      <Content style={TitleTextStyle} content={title} />
                      {isTableSource && renderCount && (
                        <div style={ContentTextStyle}>
                          Количество объектов:{' '}
                          {renderCount(totalRecords, value.name)}
                        </div>
                      )}
                    </>
                  }
                  action={
                    onRemove && (
                      <Tooltip placement="left" title="Удалить слой">
                        <CloseOutlined
                          onClick={() => {
                            onRemove(name);
                          }}
                        />
                      </Tooltip>
                    )
                  }
                />
                {isPhotoLayer && (
                  <div style={{ paddingLeft: 25, marginTop: -20 }}>
                    <PhotoMaterialStyleLegend />
                  </div>
                )}
                {value.styles && !isPhotoLayer && (
                  <div style={{ paddingLeft: 25, marginTop: -20 }}>
                    <StyleLayerLegend style={value.styles} />
                  </div>
                )}
              </>
            );
          },
        })}
      </>
    );
  },
);
